import { createRoutine } from 'redux-saga-routines';

export const getPropertyRoutine = createRoutine('GET_PROPERTY');
export const getPropertiesRoutine = createRoutine('GET_PROPERTIES');
export const getPropertiesAdminRoutine = createRoutine('GET_PROPERTIES_ADMIN');
export const addPropertyAdminRoutine = createRoutine('ADD_PROPERTY');

export const archivePropertyAdminRoutine = createRoutine('ARCHIVE_PROPERTY');
export const undoArchivePropertyRoutine = createRoutine('UNDO_ARCHIVE_PROPERTY');

export const closeBiddingRoutine = createRoutine('CLOSE_BIDDING');
export const openBiddingRoutine = createRoutine('OPEN_BIDDING');
